// extracted by css-extract-rspack-plugin
export default {"popover":"ua4cYI4v1yEmDF6E","modalHeader":"D5uwuHaG4NADUCN9"};